<div *ngIf="factors" class="row justify-content-center">
    
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Kostick</h4>
            </div>
            <div class="card-body">
                
                <h3 class="card-title">Listado de valores</h3>
                <hr>
                
                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Grado de energía'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>
                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>

                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Liderazgo'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>

                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>
                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Modo de Vida'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>

                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>
                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Naturaleza Social'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>

                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>
                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Adaptación al Trabajo'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>

                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>
                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Naturaleza Emocional'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>

                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>
                    <div *ngFor="let factor of factors" class="form-body">
                        <div *ngIf="factor.factor=='Subordinación'" class="">

                            <div class="col-md-12 text-center">
                                <h2>Factor: {{factor.factor}}</h2>
                            </div>
    
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <h3>Puntaje: {{factor.score}}</h3>
                                        <p>{{factor.dimension}}</p>
                                        <p>{{factor.description}}</p>

                                    </div>
                                </div>
                                <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>
    
                            <hr>
                        </div>
                    </div>
                    
                
            </div>
        </div>
    </div>
</div>